import type { QuizResponse } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

export const DEFAULT_RESPONSE: QuizResponse = {
  [Type]: DataTypeQuiz.QuizResponse,
  title: '',
  markdown: '',
  css: '',
  embed: '',
  selection: '',
  readinglists: [],
  resources: [],
  topics: [],
  goals: [],
  route: '',
};
